<script lang="ts">
  import { emptyMap, emptySchedule } from "../../data/empty";
  import { getPlace, getFocusedEvents } from "../../domain/map";
  import Map from "../../components/map/map.svelte";
  import MapMissing from "../../components/map/map-missing.svelte";
  import MapBanner from "../../components/map-banner.svelte";
  import MapDrawer from "../../components/map-drawer.svelte";
  import { mapPath, type QueryParams } from "../../support/links";
  import { page } from "$app/stores";
  import { parseId } from "../../params/slug";

  export let data;

  $: map = data.map || emptyMap;
  $: schedule = data.schedule || emptySchedule;
  $: events = data.events || [];
  $: places = data.places;

  $: query = $page.url.searchParams;
  $: placeId = parseId(query.get("place"));
  $: subplaceId = parseId(query.get("subplace"));
  $: eventId = parseId(query.get("event"));
  $: waypointId = parseId(query.get("waypoint"));

  // DERIVED DATA
  $: event = events.find((e) => e.id == eventId);
  $: hours = getFocusedEvents(schedule, eventId);
  $: place = getPlace(map, places, placeId);
  $: placeMapId = place ? place.mapId : null;
  $: controlsOffset = placeMapId ? 48 : 0;

  // THEME
  $: title = map ? map.title : "Map Missing";
  $: connectionColor = map ? map.connectionColor : "#ff2244";
  $: pinColor = map?.pinColor || connectionColor;
  $: waypointColor = map ? map.waypointColor : "#ffff00";
  $: backgroundColor = map ? map.backgroundColor : "#111111";

  function submapPath(query: QueryParams = {}) {
    return mapPath({
      place: placeId,
      subplace: query.place
    });
  }
</script>

<main
  style="--background-color: {backgroundColor};
         --connection-color: {connectionColor};
         --pin-color: {pinColor};
         --waypoint-color: {waypointColor};"
>
  {#if map}
    <h1 class="sr-only">Map of {title}</h1>
    <MapBanner {hours} {event} {place} linkBuilder={mapPath} />
    <Map
      {map}
      {places}
      {controlsOffset}
      activePlaceId={placeId}
      activeWaypointId={waypointId}
      linkBuilder={mapPath}
    >
      {#if placeMapId}
        <MapDrawer mapId={placeMapId} activePlaceId={subplaceId} linkBuilder={submapPath} />
      {/if}
    </Map>
  {:else}
    <MapMissing />
  {/if}
</main>

<style>
  main {
    background: var(--background-color, #111111);
    flex: 1 1 auto;
    overflow: auto;
    width: 100%;
  }
</style>
